<script type="text/ecmascript-6">

    import DoorDesignerOptions from "./mixin/DoorDesignerOptions.vue";
    import {nextTick} from "vue";

    export default {
        mixins: [
            DoorDesignerOptions
        ],
        props: {
            ranges: {
                required: true,
            },
            active_range: {
              required: true,
            },
            door_type: {
                required: true,
            },
            reference_on: {
                default() {
                    return true;
                },
            },
            mdd: {
                default() {
                    return false;
                }
            },
            main_retail_mdd: {
              default() {
                return false;
              }
            },
            reseller_designer_id: {
                default() {
                    return 0;
                }
            },
            fabricator: {
                required: true,
                type: Number
            },
            loadDoor: {},
            loading_basket_popup_text: {
                default() {
                    return {
                        title: "Basket",
                        text: "Loading your basket"
                    }
                }
            },
          designer_range_section_banners: {
            default() {
              return [];
            }
          },
          designer_full_screen_banners: {
            default() {
              return [];
            }
          },
          creating_predesigned_door: {
            default() {
              return false;
            }
          },
        },
        computed: {
            save_url() {
                if (this.door_exists) {
                    return '/basket/door/' + this.door.id;
                }

                return '/basket/door';
            },
            save_method() {
                return this.door_exists ? 'PUT' : 'POST';
            },
            door_exists() {
                return this.door.id !== undefined
            },
            left_flag_sill() {
                if (this.door.attr.side_panels !== undefined && this.door.attr.frame_style.checkedPanels.indexOf('left') !== -1) {
                    let side_variants = [2,14,15,39,51,63,67,74,78,80,82,87,88,89];
                    return side_variants.includes(this.door.attr.side_panels.left);
                } else {
                    return false;
                }
            },
            right_flag_sill() {
                if (this.door.attr.side_panels !== undefined && this.door.attr.frame_style.checkedPanels.indexOf('right') !== -1) {
                    let side_variants = [2,14,15,39,51,63,67,74,78,80,82,87,88,89];
                    return side_variants.includes(this.door.attr.side_panels.right);
                } else {
                    return false;
                }
            },
            range_panel_required(){
                return this.ranges.length > 1;
            }
        },
        methods: {
            renderAndPriceDoor(door) {
                door = JSON.parse(JSON.stringify(door));

                if(this.attributesAreValid(JSON.parse(JSON.stringify(door.attr)))) {
                    this.doorForImg = JSON.parse(JSON.stringify(door.attr));
                    this.newDoor = JSON.parse(JSON.stringify(door.attr));

                    delete this.doorForImg.door_colour_internal;
                    delete this.doorForImg.frame_colour_internal;
                    delete this.doorForImg.hardware_handle_internal;
                    delete this.doorForImg.door_location;
                    delete this.doorForImg.drainage;
                    delete this.doorForImg.hardware_cylinder;
                    delete this.doorForImg.hardware_handle_split_spindle;
                    delete this.doorForImg.hardware_lock;
                    delete this.doorForImg.key;
                    delete this.doorForImg.key_qty;
                    delete this.doorForImg.laminated_glass;
                    delete this.doorForImg.measurements;
                    delete this.doorForImg.notes;
                    delete this.doorForImg.numerals;
                    delete this.doorForImg.profile;
                    delete this.doorForImg.ramp;
                    delete this.doorForImg.reference;
                    delete this.doorForImg.restrictor;
                    delete this.doorForImg.secured_by_design;
                    delete this.doorForImg.slab_edge_colour;

                    this.doorForImg = JSON.stringify(this.doorForImg);

                    if (this.doorForImg !== this.oldDoorForImg) {
                        window.emitter.emit('img-updating', door);
                        if (this.drawfunc === null) {
                            this.drawfunc = window._.debounce((door) => {
                                if (this.lastImgController) {
                                    this.lastImgController.abort();
                                }

                                const controller = new AbortController();
                                this.lastImgController = controller;

                                window.axios.post(window.render_url + '/api/render/door', door, {
                                    signal: controller.signal,
                                }).then((result) => {
                                    if (this.lastImgController === controller) {
                                        this.lastImgController = null;
                                    }
                                    window.emitter.emit('img-updated', result.data.external);
                                }, (failed_response) => {
                                    if (failed_response?.code === 'ERR_CANCELED') {
                                        return;
                                    }
                                    if (this.lastImgController === controller) {
                                        this.lastImgController = null;
                                    }
                                });
                            }, 100);
                        }
                        this.drawfunc(door);
                        this.oldDoorForImg = this.doorForImg;
                    }

                    this.doorForPrice = JSON.parse(JSON.stringify(door.attr));
                    delete this.doorForPrice.notes;
                    delete this.doorForPrice.reference;
                    this.doorForPrice = JSON.stringify(this.doorForPrice);

                    if (this.doorForPrice !== this.oldDoorForPrice) {
                        this.oldDoorForPrice = this.doorForPrice;
                        window.emitter.emit('price-updating', door);
                        if (this.pricefunc === null) {
                            this.pricefunc = window._.debounce((door) => {
                                if (window.has_live_pricing === false) {
                                    return;
                                }

                                if (this.lastPriceController) {
                                    this.lastPriceController.abort();
                                }

                                const controller = new AbortController();
                                this.lastPriceController = controller;

                                window.axios.post('/api/price/door', door, {
                                    signal: controller.signal,
                                }).then((result) => {
                                    if (this.lastPriceController === controller) {
                                        this.lastPriceController = null;
                                    }
                                    window.emitter.emit('price-updated', {
                                        price: result.data.price,
                                        cost: result.data.cost,
                                        breakdown: result.data.breakdown,
                                        reseller_breakdown: result.data.reseller_breakdown,
                                        price_broken: false,
                                    });
                                }, (failed_response) => {
                                    if (failed_response?.code === 'ERR_CANCELED') {
                                        return;
                                    }
                                    if (this.lastPriceController === controller) {
                                        this.lastPriceController = null;
                                    }
                                    window.emitter.emit('price-updated', {
                                        price: -1,
                                        cost: 0,
                                        breakdown: {},
                                        reseller_breakdown: {},
                                        price_broken: true,
                                    });
                                });
                            }, 100);
                        }
                        this.pricefunc(door);
                        // if both variables are not null then console log the attributes in this.doorForPrice that are differnt to the attribues in this.oldDoorForPrice
                        // parse values as json as they are objects
                        // if (this.oldDoor !== null) {
                        //     let newAttributes = this.newDoor;
                        //     let oldAttributes = this.oldDoor;
                        //     let changedAttributes = [];
                        //
                        //     for (let key in newAttributes) {
                        //         if (newAttributes.hasOwnProperty(key)) {
                        //             if (JSON.stringify(newAttributes[key]) !== JSON.stringify(oldAttributes[key])) {
                        //                 changedAttributes.push(`{${key}: [${newAttributes[key]} - ${oldAttributes[key]}]}`);
                        //             }
                        //         }
                        //     }
                        //
                        //     if (changedAttributes.length > 0) {
                        //         console.log('Changed attributes:', changedAttributes);
                        //     }
                        // }

                        this.oldDoor = this.newDoor;
                    }
                }
            },
            attributesAreValid(door){
                // check if property is set before making pricing call
                if(door.hardware_lock == null || door.hardware_lock === undefined ||
                    door.hardware_hinge == null || door.hardware_hinge === undefined ||
                    door.profile == null || door.profile === undefined ||
                    door.slab == null || door.slab === undefined ||
                    door.frame_style.frame_id == null || door.frame_style.frame_id === undefined ||
                    door.external_colour == null || door.external_colour === undefined ||
                    door.door_colour_internal == null || door.door_colour_internal === undefined ||
                    door.threshold == null || door.threshold === undefined ||
                    door.cill == null || door.cill === undefined ||
                    door.door_range == null || door.door_range === undefined
                ){
                    return false;
                }

                return true;
            },
            printPage(){
                window.print();
            },
            handleNewDoor(door, reference_on = true) {
                let oldDoor = this.door;
                this.door = JSON.parse(JSON.stringify(door));
                if (door.id !== undefined) {
                    this.door.id = oldDoor.id;
                }
                if (oldDoor.attr.reference !== "") {
                    this.door.attr.reference = oldDoor.attr.reference;
                } else if (this.creating_predesigned_door) {
                    this.door.attr.reference = "Predesigned Door";
                } else if (!reference_on) {
                    this.door.attr.reference = "Retail Door";
                }
            },
            updateAttribute(val, attribute) {
                this.door.attr[attribute] = val;
            },
            swalConfirm(prompt, yes_callback, no_callback) {
                window.Swal.fire({
                    title: 'Are you sure?',
                    text: prompt,
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes'
                }).then(function () {
                    yes_callback();
                }, function () {
                    if (no_callback !== undefined) {
                        no_callback();
                    }
                })
            },
            resetDoor() {
                return this.loadDoor !== undefined ? JSON.parse(JSON.stringify(this.loadDoor)) : this.defaultDoor();
            },
            defaults() {
              return {};
            },
            defaultDoor() {
              return this.defaults()[this.active_range];
            },
            saveDoor(callback) {
                window.Swal.fire({
                    title: 'Saving',
                    text: 'We\'re validating and saving your door',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    showConfirmButton: false,
                });

                window.Swal.showLoading();

                window.axios.post(this.save_url, {
                    door: this.door,
                    technical_step_on: this.technical_should_show,
                    _method: this.save_method,
                    reseller_designer_id: this.reseller_designer_id,
                }).then(response => {
                    this.door = response.data.door;

                    if (response.data.status) {
                        nextTick(() => {
                            this.saved = true;
                        });
                        if (typeof callback === 'function') {
                            callback();
                        }
                    } else {
                        if (response.data.redirect) {
                            var itemable = response.data.type.substr(0, 1).toUpperCase() + response.data.type.substr(1).toLowerCase();
                            window.Swal.fire({
                                title: itemable + ' Exists',
                                type: 'error',
                                html: 'An ' + itemable + ' with this door already exists, click Ok to go to the ' + itemable + ' details page.',
                                showCloseButton: true,
                                showCancelButton: false,
                                showConfirmButton: true,
                                confirmButtonText: 'Ok',
                            }).then(() => {
                                window.location.href = response.data.redirect;
                            })
                        } else {
                            nextTick(() => {
                                this.saved = false;
                                $('[data-circle-loader-basket-btn-check]').toggle();
                                $('[data-circle-loader-basket-btn]').toggleClass('load-complete').hide();
                                $('[data-circle-loader-checkout-btn-check]').toggle();
                                $('[data-circle-loader-checkout-btn]').toggleClass('load-complete').hide();
                            });

                            if (response.data.validation_errors && response.data.validation_errors.length > 0) {
                                var component_id = response.data.validation_errors[0].component_id;

                                if (component_id) {
                                    window.emitter.emit('jump-to-component', {component_id: component_id});
                                }
                            }

                            this.showValidationErrors(response.data.validation_errors, callback);
                        }
                    }
                }).catch(response => {
                    var error_text = '';

                    if(window.isBing) {
                      error_text = response.data.message;
                    }
                    window.Swal.fire({
                      title: 'An error occurred',
                      text: error_text,
                      type: 'error',
                    });
                });
            },
            showValidationErrors(errors, callback) {
                var formatted_errors = '';
                var canProceed = true;

                window._.each(errors, (error) => {
                    if(window.isBing && error.rule_id) {
                      formatted_errors += '<li>' + '(' + error.rule_id + ') ' + error.string + '</li>';
                    } else {
                      formatted_errors += '<li>' + error.string + '</li>';
                    }
                    if (error.fatal) {
                        canProceed = false;
                    }
                });

                var html = '<ul class="val_errors">' + formatted_errors + '</ul>';

                window.Swal.fire({
                    title: canProceed ? 'Validation Warning' : 'Validation Error',
                    type: canProceed ? 'warning' : 'error',
                    html: html,
                    showCloseButton: true,
                    showCancelButton: true,
                    showConfirmButton: canProceed,
                    confirmButtonText: 'Proceed Anyway',
                    cancelButtonText: 'Return to Designer'
                }).then((response) => {
                    if(response.isConfirmed) {
                        callback && callback();
                    }
                })
            },
            add_door_to_basket(go_straight_to_checkout = false) {
                    this.saveDoor(() => {
                        window.Swal.fire({
                            title: this.loading_basket_popup_text.title,
                            text: this.loading_basket_popup_text.text,
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            showConfirmButton: false,
                        });

                        window.Swal.showLoading();

                        var url = '/basket/add-door?id=' + this.door.id + '&go_straight_to_checkout=' + go_straight_to_checkout;

                        setTimeout(function() {
                            window.Swal.close();
                            window.Swal.hideLoading();
                          window.location.href = url;
                        }, 200);
                    });
            },
            view_basket() {
                if (this.saved) {
                    window.location.href = '/basket/index';
                } else {
                    this.swalConfirm('Save this door before you continue?', () => {
                        this.saveDoor(() => {
                            window.location.href = '/basket/add-door?id=' + this.door.id;
                        });
                    }, () => {
                        window.location.href = '/basket/index';
                    });
                }
            },
            // override this method if you need to do anything extra before adding the door to basket - for example future have a fire door check
            handleAddToBasket(go_straight_to_checkout = false){
                this.add_door_to_basket(go_straight_to_checkout);
            },
            saveNewPredesignedDoor() {

                window.Swal.fire({
                    title: "Save New Promotional Door",
                    text: "Enter the door name:",
                    input: "text",
                    inputPlaceholder: "Door Name",
                    showCancelButton: true,
                    confirmButtonText: "Save",
                    cancelButtonText: "Cancel",
                    showLoaderOnConfirm: true,
                    showCloseButton: true,
                    reverseButtons: true,
                    allowOutsideClick: () => !window.Swal.isLoading(),

                    preConfirm: (inputValue) => {
                        const trimmedValue = inputValue?.trim();

                        if (!trimmedValue) {
                            window.Swal.showValidationMessage("Please enter a name");
                            return false;
                        }

                        return trimmedValue;
                    }
                }).then((result) => {
                    if (result.isConfirmed && result.value) {
                        const doorName = result.value;

                        window.axios.post('/predesigned-doors/create-predesigned-door', {
                            door: this.door,
                            slug: doorName.replace(/[^a-zA-Z0-9]+/g, "")
                        }).then(() => {
                            window.location.href = '/predesigned-doors';
                        }).catch(() => {
                            window.Swal.fire({
                                icon: "error",
                                title: "Error",
                                text: "An error occurred while saving the promotional door"
                            });
                        });
                    }
                });
            },
        },
        watch: {
            'door': {
                handler: window._.debounce(function (new_door, old_door) {
                    this.saved = false;
                    window.emitter.emit('door-updated', new_door);
                }, 200),
                deep: true,
            },
            'door.attr.reference': {
              handler: window._.debounce(function () {
                this.door.attr.reference = this.door.attr.reference.replace(/[^a-zA-Z0-9. ]+/g," ");
              }, 50),
            },
        },
        data() {
            return {
                current_request_count: 0,
                door: this.resetDoor(),
                saved: this.loadDoor !== undefined,
                saving: false,
                measurements_breakdown_open: false,
                measurements_breakdown: [],
                lead_time_breakdown: [],
                limits: [],
                show_navigation: false,
                visible_designer_configurator_components: [],
                drawfunc: null,
                pricefunc: null,
                lastPriceController: null,
                lastImgController: null,
                doorForImg: null,
                oldDoor: null,
                newDoor: null,
                oldDoorForImg: null,
                doorForPrice: null,
                oldDoorForPrice: null,
                door_designer_options: {
                    show_technical: true,
                },
                pendingUrls: [],
            }
        },
        mounted() {
            const vueThis = this;
            nextTick(function () {
                vueThis.renderAndPriceDoor(vueThis.door);
            });

            window.emitter.on('request-count-inc', ({url, id}) => {
                this.current_request_count++;
                this.pendingUrls.push({
                    url,
                    id,
                    status: 'pending',
                    shortUrl: url.replace(/^\/api\/options\/\d+\//, '').split('?')[0],
                    isDuplicate: this.pendingUrls.some(u => u.url === url && u.id !== id),
                    isReprocessed: this.pendingUrls.some(u => u.shortUrl === url.replace(/^\/api\/options\/\d+\//, '').split('?')[0] && u.id !== id)
                });
                window.emitter.emit('current-request-count-updated', { current_request_count: this.current_request_count, pendingUrls: this.pendingUrls });

            });
            window.emitter.on('request-count-dec', ({url, id, reason}) => {
                console.log("Stop: ", url, id, reason);
                this.current_request_count--;

                this.pendingUrls = this.pendingUrls.map(u => {
                    if(u.url === url && u.id === id) {
                        u.status = reason;
                    }
                    return u;
                });

                if(this.current_request_count === 0) {
                    this.renderAndPriceDoor(this.door);
                }

                window.emitter.emit('current-request-count-updated', { current_request_count: this.current_request_count, pendingUrls: this.pendingUrls });
            });

            window.emitter.on('door-updated', (door) => {
                setTimeout(() => {
                    if(this.current_request_count === 0) {
                        this.renderAndPriceDoor(this.door);
                    }
                }, 250);
            });

            window.emitter.on('clear-pending-urls', () => {
                this.pendingUrls = [];
                window.emitter.emit('current-request-count-updated', { current_request_count: this.current_request_count, pendingUrls: this.pendingUrls });
            });

            if(!this.reference_on) {
                this.door.attr.reference = 'Retail Door';
            }

            window.emitter.on('toggle-designer-navigation', () => {
                if(this.show_navigation == false) {
                    window.emitter.emit('open-designer-navigation');
                } else {
                    window.emitter.emit('close-designer-navigation');
                }
            });

            window.emitter.on('close-designer-navigation', () => {
                $('body').removeClass('designer-navigation-open');
                this.show_navigation = false;
                $('.back-to-top-btn span').html('MENU');
            });

            window.emitter.on('open-designer-navigation', () => {
                $('body').addClass('designer-navigation-open');
                this.show_navigation = true;
                window.emitter.emit('update-navigation');
                $('.back-to-top-btn span').html('X');

                $('body').on('click', () => {
                    window.emitter.emit('close-designer-navigation');
                });
            });

            window.emitter.on('jump-to-component', (component) => {
                window.emitter.emit('close-designer-navigation');
                let component_element = $("[data-designer-component-id='" + component + "']");

                if(component_element.length > 0){
                    $('html, body').animate({
                        scrollTop: component_element.offset().top - 125
                    }, 500);
                } else {
                    if(window.isBing){
                        window.Swal.fire('Component for ' + component + ' not found');
                    }
                }
            });

            window.emitter.on('update-navigation', () => {
                let visible_designer_configurator_components = [];

                $.each($('[data-designer-component-id]'), function () {
                    //checks if the div itself is visible and makes sure any parent divs are also visible using offset. (if it's at 0, 0 coords it's probably not really visible)
                    if ($(this).is(':visible') && $(this).offset().top > 0) {
                        visible_designer_configurator_components.push($(this).data('designer-component-id'));
                    }
                });

                this.visible_designer_configurator_components = visible_designer_configurator_components;
            });

            window.emitter.on('add-to-basket', () => {
                this.handleAddToBasket(false);
            });

            window.emitter.on('add-to-basket-and-go-to-checkout', () => {
                this.handleAddToBasket(true);
            });

            window.emitter.on('save-new-predesigned-door', () => {
                this.saveNewPredesignedDoor();
            });

            window.emitter.on('view-basket', () => {
                this.view_basket();
            });

            window.emitter.on('reset-button-clicked', () => {
                this.door = this.resetDoor();
            });

            window.emitter.on('get-measurements-breakdown', () => {
                window.axios.post('/getMeasurementsBreakdown', {
                    'attributes': this.door.attr,
                }).then((result) => {
                    this.measurements_breakdown = result.data;

                    let attributesHtml = '';

                    attributesHtml += '<tr><td>Overall Width</td><td>'+this.door.attr.measurements.overall_width+'</td></tr>';
                    attributesHtml += '<tr><td>Overall Height</td><td>'+this.door.attr.measurements.overall_height+'</td></tr>';

                    $.each(this.measurements_breakdown, function (key, value) {
                        attributesHtml += '<tr><td>'+key+'</td><td>'+value+'</td></tr>';
                    });

                    window.Swal.fire({
                        title: 'Measurements Breakdown',
                        html: '<table class="table align-left _bordered _slim">'+attributesHtml+'</table>',
                        showCloseButton: true,
                    })
                }, (failed_response) => {
                    window.Swal.fire('Measurements Breakdown failed to load');
                });
            });

            window.emitter.on('get-lead-time-breakdown', () => {
                window.axios.post('/getLeadTimeBreakdown', {
                    'attributes': this.door.attr,
                }).then((result) => {
                    this.lead_time_breakdown = JSON.stringify(result.data);

                    window.Swal.fire({
                        title: 'Lead Time',
                        html: '<div>'+this.lead_time_breakdown+'</div>',
                        showCloseButton: true,
                    })
                }, (failed_response) => {
                    window.Swal.fire('Lead Time failed to load');
                });
            });

            window.emitter.on('toggle-thumbnail-helper-hover', () => {
                $('.designer-question-tiled-layout .tile').toggleClass('_with-thumbnail-helper-hover');
            });

            window.emitter.on('new-door', (door, reference_on = true) => {
                this.handleNewDoor(door, reference_on);
            });
        },
        onUnmounted() {
            if (this.lastImgController) {
                this.lastImgController.abort();
            }
            if (this.lastPriceController) {
                this.lastPriceController.abort();
            }
            window.emitter.off('toggle-designer-navigation');
            window.emitter.off('close-designer-navigation');
            window.emitter.off('open-designer-navigation');
            window.emitter.off('jump-to-component');
            window.emitter.off('update-navigation');
            window.emitter.off('add-to-basket');
            window.emitter.off('add-to-basket-and-go-to-checkout');
            window.emitter.off('save-new-predesigned-door');
            window.emitter.off('view-basket');
            window.emitter.off('reset-button-clicked');
            window.emitter.off('range-updated');
            window.emitter.off('get-measurements-breakdown');
            window.emitter.off('get-lead-time-breakdown');
            window.emitter.off('toggle-thumbnail-helper-hover');
            window.emitter.off('door-updated');
        },
    }
</script>
